<template>
  <div class="bottom-summary-card flex flex-col items-center text-center tracking-0.15px">
    <div
      v-if="card.icon && card.icon.isIcon"
      class="bottom-summary-card__icon bg-primary-light w-28 h-28 rounded-full flex flex-shrink-0 mb-4"
      v-dompurify-html:svg="iconSource"
    />
    <div
      v-else-if="card.icon && card.icon.source"
      class="bottom-summary-card__image w-28 h-28 flex-shrink-0 mb-4"
      role="img"
      :aria-label="card.icon.alt"
      :style="{ '--icon-mask': `url('${card.icon.source}')` }"
    />

    <div
      v-if="card.description"
      v-dompurify-html="card.description"
      class="richtext mb-6"
    ></div>

    <KButton
      v-if="card.buttonLink && card.buttonLink.href"
      theme="primary"
      :aria-label="card.buttonLabel || card.buttonLink.title"
      @click="goToLink"
      @keypress.enter.space="goToLink"
    >
      {{ card.buttonLabel || card.buttonLink.title }}
    </KButton>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { BottomSummaryPP } from '@/model'
import useRemoteIcon from '@/hooks/useRemoteIcon'
import KButton from '@/components/atoms/Button/index.vue'

export default defineComponent({
  name: 'BottomSummaryCard',
  components: {
    KButton
  },
  props: {
    card: {
      type: Object as () => BottomSummaryPP,
      required: true
    }
  },
  setup (props) {
    const iconSource = props.card.icon?.isIcon && props.card.icon.source
      ? useRemoteIcon(props.card.icon.source)
      : null

    function goToLink () {
      if (props.card.buttonLink?.href) {
        window.open(props.card.buttonLink.href, '_parent')
      }
    }

    return { iconSource, goToLink }
  }
})
</script>

<style>
.bottom-summary-card {
  max-width: 340px;

  &__icon svg {
    @apply w-20 h-20 m-auto fill-current text-primary;
  }

  &__image {
    @apply bg-primary;
    -webkit-mask-image: var(--icon-mask);
    mask-image: var(--icon-mask);
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-position: center;
    mask-position: center;
    -webkit-mask-size: contain;
    mask-size: contain;
  }

  .k-btn--box {
    width: 200px;
    max-width: 100%;
    height: auto;
    min-height: 48px;
    padding: 0.5rem 1rem;
  }

  .k-btn__text-content {
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
  }
}
</style>
